import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ReserveAccountModel } from 'Pages/orders_design'

export type ReserveAccountState = {
	available: boolean
	selected: boolean
	locked: boolean
}

export const reserveAccountInitialState: ReserveAccountState = {
	available: false,
	selected: false,
	locked: true,
}

export type ReserveAccountKey = keyof ReserveAccountState

export type ReserveAccountOptions = Partial<Record<ReserveAccountKey, boolean>>

export namespace reserveAccountNS {
	export type setReserveAccountOptions = PayloadAction<{ newOptions: ReserveAccountOptions }>
	export type checkReserveAccountPossibility = PayloadAction<{ inn: number; product_ids: number[] }>
	export type createReserveAccount = PayloadAction<{ id: number; data: ReserveAccountModel }>
	export type sendOrderWithoutReserveAccount = PayloadAction<{ id: number; reloadOrder?: boolean }>
	export type updateReserveAccountInOrder = PayloadAction<{ id: number }>
	export type showModalAfterOutOfficeAppointment = PayloadAction<{ id: number }>
}

export const reserveAccountSlice = createSlice({
	name: 'reserveAccount',
	initialState: reserveAccountInitialState,
	reducers: {
		setReserveAccountOptions: (state, action: reserveAccountNS.setReserveAccountOptions) => {
			const newState = { ...state, ...action.payload.newOptions }
			return newState
		},
		checkReserveAccountPossibility: (
			state,
			action: reserveAccountNS.checkReserveAccountPossibility
		) => {},
		createReserveAccount: (state, action: reserveAccountNS.createReserveAccount) => {},
		sendOrderWithoutReserveAccount: (
			state,
			action: reserveAccountNS.sendOrderWithoutReserveAccount
		) => {},
		updateReserveAccountInOrder: (
			state,
			action: reserveAccountNS.updateReserveAccountInOrder
		) => {},
		showModalAfterOutOfficeAppointment: (
			state,
			action: reserveAccountNS.showModalAfterOutOfficeAppointment
		) => {},
	},
})
